<app-new-hire-packet-stepper></app-new-hire-packet-stepper>

<app-onboarding-task-checklist></app-onboarding-task-checklist>